import React, { Component } from 'react'
import sectiondata from '../../data/sections.json'
import parse from 'html-react-parser'
import useFetch from '../../Hooks/useFetch.js'

function OurPartner({ title, data }) {
  console.log(data, title)
  let publicUrl = process.env.PUBLIC_URL + '/'
  let imagealt = 'image'
  // let data = sectiondata.partner

  return (
    <div className='client-area pd-top-92 pd-bottom-100'>
      <div className='container'>
        <div className='section-title text-center'>
          <h2
            className='title'
            style={{ fontFamily: 'Optima Bold', textTransform: 'uppercase' }}
          >
            {title}
          </h2>
        </div>
        <div className='client-slider d-flex justify-content-around'>
          {data?.map((item, i) => (
            <div key={i} className='item'>
              <div className='thumb'>
                <img src={item.fields.file.url} alt='client' />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OurPartner
